module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.13216/img/homepage-header-image.png"